export default "__VITE_ASSET__a65deb76__"